import React, { ChangeEvent, FC } from 'react'
import SpaceAroundWrap, { SpaceAround } from '@mailstep/design-system/ui/Elements/SpaceAround'
import withFormikToProps from '@utils/formik/withFormikToProps'
import Checkbox from '@mailstep/design-system/ui/Forms/Checkbox'
type Props = {
  value?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  spaceAround?: SpaceAround
}

const CheckboxField: FC<Props> = ({ value, onChange, spaceAround = false, ...rest }) => (
  <SpaceAroundWrap spaceAround={spaceAround}>
    <Checkbox checked={!!value} onChange={onChange} {...rest} />
  </SpaceAroundWrap>
)

export default withFormikToProps(CheckboxField)
